/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { LableFromEnums } from "../../../utilities";
import { ToastContainer, toast } from "react-toastify";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { AssociateBookingSummary } from "./AssociateBookingSummary";
import { ConfirmCancelModal } from "../CourtsBooking/ConfirmCancelModal";
import {
  GetAssociateBookingDetails,
  GetGroupSlots,
} from "../../../utilities/api/associateBooking";

const AssociateBookingDetails = () => {
  const [openModal, setOpenModal] = useState(false);
  const [modalName, setModalName] = useState("");
  const [printing, setPrinting] = useState(false);
  const EnumsObj = { ...useAppSelector((state) => state.enumsArray.Enums) };
  const { name } = useAppSelector((state) => state.verifiedUser.UserRole?.role);
  const id = useLocation().state;
  const navigate = useNavigate();
  const [bookingDetails, setBookingDetails] = useState<any>({});
  const [slots, setSlots] = useState<any>([]);
  const componentRef = useRef<HTMLDivElement>(null);

  const GetData = async () => {
    const _details = await GetAssociateBookingDetails(id);
    const _slots = await GetGroupSlots(id, "false");
    if (_details?.statusCode === 200) {
      setBookingDetails(_details.data);
    } else {
      toast.error(_details.response.data.message);
    }
    if (_slots.statusCode === 200) {
      let data = [] as any;
      _slots.data.forEach((item: any) => {
        item.list.forEach((elem: any) => {
          data.push(elem);
        });
      });
      setSlots(data);
    }
  };

  useEffect(() => {
    GetData();
  }, []);



  const IsReschedule = ["confirmed", "pending", "ongoing"].includes(
    bookingDetails.status
  );

  const IsCancel =
    bookingDetails.paymentStatus === "pending" &&
    ["confirmed", "pending"].includes(bookingDetails.status);
  const IsRefund =
    ["paid", "partially_paid"].includes(bookingDetails.paymentStatus) &&
    ["completed"].includes(bookingDetails.status);

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleShowCancel = () => {
    setModalName("Cancel Associate Booking");
    setOpenModal(true);
  };

  const handleReschedule = () => {
    navigate("/reschedule-associate-booking", { state: bookingDetails });
  };

  const handleRefund = () => {
    setModalName("Refund Associate Booking");
    setOpenModal(true);
  };
  const handlePrint = () => {

    setPrinting(true);
    window.open(
      "/printing/?type=summary&prefix=ACB&id=" + bookingDetails.id + "&hash=" + bookingDetails.hash,
      "_blank"
    );
    setTimeout(() => {
      setPrinting(false);
    }, 2000);

  };

  const handleGenerateInvoice = () => {
    navigate("/associate-generate-invoice", { state: bookingDetails });
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="mb-0">
                Associate Booking Details
              </Card.Title>
            </div>
            <hr />
            <Col lg={12}>
              <div className="reschedule-details">
                <Row className="text-start row-mb">
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Customer Name
                    </span>
                    <span className="user-info">
                      {bookingDetails?.user?.firstName}{" "}
                      {bookingDetails?.user?.lastName}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Booking Status
                    </span>
                    <span className="user-info">
                      {LableFromEnums(bookingDetails.status, EnumsObj)}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Company Name
                    </span>
                    <span className="user-info">
                      {bookingDetails?.companyName || "-"}
                    </span>
                  </Col>
                </Row>
                <Row className="text-start row-mb">
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Contact Number
                    </span>
                    <span className="user-info">
                      {bookingDetails.user?.countryCode}{" "}
                      {bookingDetails.user?.phone}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Payment Status
                    </span>
                    <span className="user-info">
                      {LableFromEnums(bookingDetails.paymentStatus, EnumsObj)}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Sports Name
                    </span>
                    <span className="user-info">
                      {bookingDetails.sportName}
                    </span>
                  </Col>
                </Row>
                <Row className="text-start row-mb">

                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Payment Mode
                    </span>
                    <span className="user-info">
                      {LableFromEnums(bookingDetails.paymentMode, EnumsObj)}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Payment Method
                    </span>
                    <span className="user-info">
                      {bookingDetails?.bookingPayments?.length > 0
                        ? LableFromEnums(
                          bookingDetails.bookingPayments[
                            bookingDetails.bookingPayments.length - 1
                          ].payment.method || "-",
                          EnumsObj
                        )
                        : "-"}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Booked by
                    </span>
                    <span className="user-info">
                      {bookingDetails.createdByUser?.firstName}{" "}
                      {bookingDetails.createdByUser?.lastName}
                    </span>
                  </Col>
                </Row>
                <Row className="text-start">
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Amount{" "}
                    </span>
                    <span className="user-info">
                      <span className="rupees-symbol">&#8377;</span>{" "}
                      {bookingDetails.totalAmount?.toFixed(2)}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Booked Period
                    </span>
                    <span className="fs-7 fw-semibold">
                      {bookingDetails?.startDate} to {bookingDetails?.endDate}
                    </span>
                  </Col>
                </Row>
              </div>
            </Col>
            <hr />
            <Row className="text-start row-mb">
              <Col lg={12}>
                <div className="fw-semibold">Summary: </div>
              </Col>
            </Row>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Courts Name</th>
                  <th>No. of Slot</th>
                  <th>Time</th>
                  <th>Rate</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {slots?.map((item: any, index: number) => {
                  return (
                    <tr key={"slots" + index}>
                      <td>{item.bookingDay}</td>
                      <td>
                        {item.combinedCourts?.map((elem: any, index: number) =>
                          index !== item.combinedCourts?.length - 1
                            ? `${elem.courtName}, `
                            : elem.courtName
                        )}
                      </td>
                      <td>{item.noOfSlots}</td>
                      <td>
                        {item.startTime} to {item.endTime}
                      </td>
                      <td>
                        <span className="rupees-symbol">&#8377;</span>{" "}
                        {item.ratePerSlot?.toFixed(2)}
                      </td>
                      <td>
                        <span className="rupees-symbol">&#8377;</span>{" "}
                        {item.totalAmount?.toFixed(2)}
                      </td>
                    </tr>
                  );
                })}

                <tr className="table-group-divider">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <th>Total Amount</th>
                  <td>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingDetails.subTotal?.toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <th>Total Tax</th>
                  <td>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingDetails.totalTax?.toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <th>Total Amount to Pay</th>
                  <td>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingDetails.totalAmount?.toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <th>Paid Amount</th>
                  <td>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(bookingDetails.totalPaidAmount)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <th>Balance Amount</th>
                  <td>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(
                      bookingDetails.totalAmount -
                      bookingDetails.totalPaidAmount
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            <Row className="text-start row-mb">
              {bookingDetails.bookingRemarks?.length !== 0 && (
                <Col lg={12}>
                  <div className="fw-semibold">
                    <span className="d-block">Remarks : </span>
                    {bookingDetails.bookingRemarks?.map((item: any) => {
                      return (
                        <span
                          key={item.id}
                          className="badge bg-success d-block w-100 mb-2 text-start text-wrap"
                        >
                          Date : {item.createdAt}, Remark For :{" "}
                          {LableFromEnums(item.remarkFor, EnumsObj)}, Remark :{" "}
                          {item.remarkText}
                        </span>
                      );
                    })}
                  </div>
                </Col>
              )}
            </Row>
            <hr />
            <Row>
              <Col lg={8} className="text-start">
                <Button
                  onClick={handleReschedule}
                  type="button"
                  bname="Reschedule"
                  name="reschedule"
                  id="reschedule"
                  className={
                    IsReschedule
                      ? "btn btn-light rounded-1 me-3"
                      : "btn btn-light rounded-1 me-3 d-none"
                  }
                ></Button>
                {name === "SUPER_ADMIN" && (
                  <>
                    <Button
                      onClick={handleShowCancel}
                      type="button"
                      bname="Cancel Booking"
                      name="cancelbooking"
                      id="cancelbooking"
                      className={
                        IsCancel
                          ? "btn btn-light rounded-1 me-3"
                          : "btn btn-light rounded-1 me-3 d-none"
                      }
                    ></Button>
                    <Button
                      onClick={handleRefund}
                      type="button"
                      bname="Refund"
                      name="refund"
                      id="refund"
                      className={
                        IsRefund
                          ? "btn btn-light rounded-1 me-3"
                          : "btn btn-light rounded-1 me-3 d-none"
                      }
                    ></Button>
                    <Button
                      onClick={handleGenerateInvoice}
                      type="button"
                      bname="Generate Invoice"
                      name="invoice"
                      id="invoice"
                      className={
                        bookingDetails.status !== "cancelled"
                          ? "btn btn-light rounded-1 me-3"
                          : "btn btn-light rounded-1 me-3 d-none"
                      }
                    ></Button>
                  </>
                )}
              </Col>
              <Col lg={4} className="text-end">
                <Button
                  onClick={handlePrint}
                  type="button"
                  name="printsummary"
                  id="printsummary"
                  className="btn btn-primary rounded-1"
                  bname={printing ? "Printing" : "Print Summary"}
                  disabled={printing}
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <div style={{ display: "none" }}>
        <AssociateBookingSummary newRef={componentRef} />
      </div>
      <ConfirmCancelModal
        show={openModal}
        handleClose={handleClose}
        name={modalName}
        id={bookingDetails.id}
        GetData={GetData}
      />
      <ToastContainer />
    </>
  );
};
export { AssociateBookingDetails };
